import Footer from "@/components/footer/footer";

export default function Rodape() {
    function currentYear() {
        const data = new Date();

        return data.getFullYear().toString()
    }

    return (
        <Footer>
            <p>Grupo Estado © {currentYear()}. Todos os direitos reservados</p>
            <p>S/A O Estado de S. Paulo | CNPJ 61.533.949/0001-41 <br/> Av. Eng. Caetano Álvares, 55</p>
            <p><small>v24.1204</small></p>
        </Footer>
    )
}
